module.exports = __webpack_public_path__ + "media/icons/naped-przod-blue@2x-cfce32df.png";